import axios from 'axios';
var xml2js = require('xml2js');
var parser = new xml2js.Parser();

export default class Franquias {

     static async getFranquia(codigofranquia) {

        return new Promise((resolve, reject)=>{

            axios.post("https://uiyek91vqe.execute-api.us-east-1.amazonaws.com/prod/franchise/search", {
                "codigofranquia":String(codigofranquia)
            })
            .then((response) => {
                let data = response.data
                if ( data.success ) {
                    resolve(data.data[0])
                } else {
                    reject(null)
                }
            })
            .catch((err)=> {
                reject(null)
            })

        })
    }

}